const ACCELEROMETER_COLORS = [
    "#7ce7ff",
    "#24a9e8",
    "#1e70b1"
];

const ACCELEROMETER_COLOR_INDICATOR = "#ffba00";

const ACCELEROMETER_COLOR_DOTS = "#989898";

const LINE_CHART_COLOR = "#002B45"

const BAR_CHART_CREDIT = "#F5D374";

const BAR_CHART_ACCOUNT_DEBIT = "#FCB900";

const BAR_CHART_CREDIT_OTHER_BANKS = "#7cd6e6";

const BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS = "#40c4df";

module.exports = {
    ACCELEROMETER_COLORS,
    ACCELEROMETER_COLOR_INDICATOR,
    ACCELEROMETER_COLOR_DOTS,
    BAR_CHART_CREDIT,
    BAR_CHART_ACCOUNT_DEBIT,
    BAR_CHART_CREDIT_OTHER_BANKS,
    BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS,
    LINE_CHART_COLOR
};
